function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HEADER_SWITCHER_PRODUCT_CLICKED, HEADER_SWITCHER_PRODUCT_HOVERED } from "constants/bigbrain-event-types";
import { useRef, useEffect } from "react";
import { StyledProductsSwitcher } from "./products-switcher.scss";
import { MAIN_PRODUCTS, ADDITIONAL_PRODUCTS } from "./consts";
import PictureComponent from "/components/core/picture/picture-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { trackEvent } from "/services/bigbrain-service";
import classNames from "classnames";
import { LAST_ACCOUNT_SLUG } from "constants/cookies";
import { getCookie } from "services/cookies-service";
import { LocalizedProductsHeaderLinks } from "constants/localized-links";
import { isExistingUserInHeader } from "services/monday-platform/existing-accounts-service";
const ProductsSwitcher = (props)=>{
    const { translate, setShowproductsSwithcer, showproductsSwithcer, localeId, persistantCookies } = props;
    const EXISTING_USER = "existing_user";
    const NEW_USER = "new_user";
    const isExistingUser = isExistingUserInHeader(persistantCookies);
    const lastAccountSlug = getCookie(LAST_ACCOUNT_SLUG);
    const ref = useRef();
    useEffect(()=>{
        const onPopUpClose = ()=>{
            if (showproductsSwithcer) {
                setShowproductsSwithcer(false);
            }
        };
        const checkIfClickedOutside = (e)=>{
            if (ref.current && !ref.current.contains(e.target)) {
                onPopUpClose();
            }
        };
        document.addEventListener("click", checkIfClickedOutside);
        return ()=>{
            document.removeEventListener("click", checkIfClickedOutside);
        };
    }, [
        showproductsSwithcer,
        setShowproductsSwithcer
    ]);
    const renderProduct = (product, openInDifferentTab)=>{
        const linkProps = {
            href: isExistingUser ? `https://${lastAccountSlug}.${product === null || product === void 0 ? void 0 : product.productStoreLink}` : product === null || product === void 0 ? void 0 : product.miniSiteLink,
            className: "product",
            onClick: ()=>{
                trackEvent(HEADER_SWITCHER_PRODUCT_CLICKED, {
                    kind: product === null || product === void 0 ? void 0 : product.name,
                    info1: isExistingUser ? EXISTING_USER : NEW_USER
                });
            },
            onMouseEnter: ()=>{
                trackEvent(HEADER_SWITCHER_PRODUCT_HOVERED, {
                    kind: product === null || product === void 0 ? void 0 : product.name,
                    info1: isExistingUser ? EXISTING_USER : NEW_USER
                });
            }
        };
        if (openInDifferentTab) {
            linkProps.target = "_blank";
        }
        return /*#__PURE__*/ _jsxs("a", _object_spread_props(_object_spread({}, linkProps), {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "icon-wrapper",
                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                        src: product === null || product === void 0 ? void 0 : product.iconLink,
                        alt: product === null || product === void 0 ? void 0 : product.name
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "product-name",
                    children: translate(product === null || product === void 0 ? void 0 : product.name)
                }),
                (product === null || product === void 0 ? void 0 : product.hasBetaTag) && /*#__PURE__*/ _jsx("div", {
                    className: "beta-tag",
                    children: translate("header.tabs.solutions.byProduct.dev.beta")
                })
            ]
        }));
    };
    const LOCALIZED_MAIN_PRODUCTS = MAIN_PRODUCTS.map((linkObject)=>{
        var _LocalizedProductsHeaderLinks_localeId;
        return _object_spread_props(_object_spread({}, linkObject), {
            miniSiteLink: ((_LocalizedProductsHeaderLinks_localeId = LocalizedProductsHeaderLinks[localeId]) === null || _LocalizedProductsHeaderLinks_localeId === void 0 ? void 0 : _LocalizedProductsHeaderLinks_localeId[linkObject.name]) || linkObject.miniSiteLink
        });
    });
    return /*#__PURE__*/ _jsxs(StyledProductsSwitcher, {
        className: classNames("products-switcher", {
            "is-existing": isExistingUser
        }),
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "main-products-title-wrapper",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "main-product-title",
                    children: translate("header.productsSwitcher.exploreFeaturedProducts")
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "main-products-wrapper",
                children: LOCALIZED_MAIN_PRODUCTS.map((product, index)=>renderProduct(product, false, index))
            }),
            !isExistingUser && /*#__PURE__*/ _jsxs("div", {
                className: "bottom-section",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "separator-line"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "additional-products-title-wrapper",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "additional-products-title",
                            children: [
                                translate("header.productsSwitcher.moreProducts"),
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "additional-products-wrapper",
                        children: ADDITIONAL_PRODUCTS.map((product, index)=>renderProduct(product, true, index))
                    })
                ]
            })
        ]
    });
};
export default withGenericConfig(ProductsSwitcher);
